import Vue from "vue"
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import Documents from '@/components/widgets/documents'
import Customers from '@/components/widgets/customers'
import DatePicker from 'vue2-datepicker'
import SortedTablePlugin from "vue-sorted-table"
import Loading from '@/components/widgets/Loading.vue'
import moment from "moment";

const _ = require('lodash')

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default {
  components: {
    DatePicker,
    Documents,
    Customers,
    Loading
  },
  mixins: [validationMixin],
  validations: {
    formData: {
      paid_at: { required },
      amount: { required },
      bank_account_detail: { required },
      ref_id: { required: requiredIf(function() {
        return this.formData.type === 'quotation'
      }) },
      customer_id: { required: requiredIf(function() {
        return this.formData.type === 'customer'
      }) },
    },
  },
  data() {
    return {
      max: null,
      loading: false,
      docOpened: false,
      customerOpened: false,
      perPage: 6,
      sortBy: 'name',
      currentPage: 1,
      sortDesc: false,
      sortByFormatted: true,
      filterByFormatted: true,
      sortable: true,
      bank_account_list: [],
      customerFields: [
        { 
          key: 'code', 
          label: 'รหัส', 
          sortable: true, 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2'
        },
        { 
          key: 'name', 
          label: 'ชื่อ - นามสกุล', 
          sortable: true, 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-left text-gray-400 td-top text-xs-1/2'
        },
        { 
          key: 'address', 
          label: 'ที่อยู่', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-left text-gray-400 td-top text-xs-1/2'
        },
        { 
          key: 'tax_id', 
          label: 'เลขประจำตัวผู้เสียภาษี', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-left text-gray-400 td-top text-xs-1/2'
        },
        { 
          key: 'contact', 
          label: 'ติดต่อ', 
          sortable: true, 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-left text-gray-400 td-top text-xs-1/2'
        },
        { 
          key: 'action', 
          label: '#', 
          thClass: 'text-center font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 text-center td-top text-xs-1/2',
        }
      ],
      customer: [],
      // fields: [
      //   { 
      //     key: 'bill_code', 
      //     label: 'รหัส',
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'td-top text-xs-1/2',
      //     sortable: true 
      //   },
      //   { 
      //     key: 'bill_name', 
      //     label: 'ชื่อ',
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2',
      //     sortable: true 
      //   },
      //   { 
      //     key: 'customer', 
      //     label: 'ลูกค้า',
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2',
      //     sortable: true 
      //   },
      //   { 
      //     key: 'bill_total_qty', 
      //     label: 'รวมจำนวน(หน่วย)',
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2',
      //     class: 'text-right',
      //     sortable: true 
      //   },
      //   { 
      //     key: 'bill_total_length', 
      //     label: 'รวมยาว(m)',
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2', 
      //     class: 'text-right',
      //     sortable: true 
      //   },
      //   { 
      //     key: 'bill_length_use', 
      //     label: 'รวมยาวใช้จริง(m)',
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2',
      //     class: 'text-right',
      //     sortable: true 
      //   },
      //   { 
      //     key: 'bill_grand_total', 
      //     label: 'ยอดรวมสุทธิ',
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2',
      //     class: 'text-right',
      //     sortable: true
      //   },
      //   { 
      //     key: 'bill_manipulator', 
      //     label: 'ผู้ทำรายการ', 
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2',
      //     sortable: true 
      //   },
      //   { 
      //     key: 'status', 
      //     label: 'สถานะ', 
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2',
      //     sortable: true 
      //   },
      //   { 
      //     key: 'action', 
      //     label: '#', 
      //     thClass: 'font-weight-bold text-xs-1/2',
      //     tdClass: 'text-gray-400 td-top text-xs-1/2',
      //   }
      // ],
      fields: [
        {
          key: "quotation_no",
          label: "เลขที่ใบเสนอราคา",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "quotation_date",
          label: "ลงวันที่",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "customer_detail.name",
          label: "ชื่อลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "customer_detail.company_name",
          label: "บริษัท",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "grandtotal",
          label: "มูลค่า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "creator_detail.name",
          label: "ผู้จัดทำ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "status",
          label: "สถานะ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          class: "text-right",
        },
      ],
      items: [],
      // ตัวเลือกประเภท VAT (ต้องตรงกับ tax_type ของบิลที่จะนำมัดจำไปใช้) — 0=ไม่มี, 1=แยก, 2=รวม
      taxTypeOptions: [
        { value: 0, text: 'บิลไม่มี VAT' },
        { value: 1, text: 'บิลแยก VAT' },
        { value: 2, text: 'บิลรวม VAT' },
      ],
      formData: {
        document_no: '',
        bank_account_detail: null,
        paid_at: null,
        amount: null,
        tax_type: 0,
        customer_id: null,
        receipt_id: null,
        ref_id: null,
        type: 'customer',
        note: '',
      }
    }
  },
  computed: {
    rows() {
      return this.items.length
    },
    // แสดง preview การคำนวณ VAT (สูตรตรงกับ computeDepositVat ฝั่ง backend)
    vatBreakdown() {
      // amount = "จำนวนเงินที่รับจริง (สุทธิ รวม VAT)" เสมอ ทุก type → grandTotal = amount
      const amount = parseFloat(this.formData.amount) || 0
      const taxType = parseInt(this.formData.tax_type) || 0
      const r2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100

      if (taxType === 1 || taxType === 2) {
        // มี VAT: ถอด VAT จากยอดสุทธิ (amount รวม VAT แล้ว)
        const beforeVat = r2(amount * 100 / 107)
        const vat = r2(amount - beforeVat)
        return { beforeVat, vat, grandTotal: r2(amount) }
      }
      // ไม่มี VAT
      return { beforeVat: r2(amount), vat: 0, grandTotal: r2(amount) }
    }
  },
  mounted() {
    this.onInitData()
    this.onLoadBankAccount()
  },
  watch:{
    "formData.amount"(new_val, old_val) {
      let newValF = parseFloat(new_val);
      let maxF = parseFloat(this.max);

      if (newValF > maxF) {
        this.$nextTick(() => {
          this.formData.amount = maxF;
        });
      }
    },
  },
  methods: {
    onClearData() {
      this.items = []
      this.customer = []
      this.formData.document_no = ''
      this.formData.paid_at = null
      this.formData.amount = 0
      this.formData.tax_type = 0
      this.formData.customer_id = ''
      this.formData.receipt_id = null
      this.formData.ref_id = null
      this.formData.type = 'customer'
      this.formData.note = ''
    },
    // สลับโหมด (ใบเสนอราคา <-> เลือกลูกค้าเอง) ต้องล้าง id ของโหมดเดิมด้วย
    // ไม่งั้นค่าเก่าค้างแล้วถูกส่งไปพร้อมกัน (เช่นเลือกใบเสนอราคาไว้ก่อน แล้วสลับมาเลือกลูกค้าเอง
    // ref_id เดิมยังติดไป -> backend ยึด quotation แล้วทับ customer ที่เพิ่งเลือก)
    resetData(){
      this.items = []
      this.customer = []
      this.formData.ref_id = null
      this.formData.customer_id = null
      this.formData.amount = null
      this.max = null
      this.$v.formData.$reset()
    },
    balckToDepositList() {
      this.$router.push("/deposit")
    },
    onRemoveDocument(id) {
      const index = _.findIndex(this.items, function(o) { return o.uuid == id })
      this.items.splice(index, 1)
    },
    onInitDocuments(items) {
      this.docOpened = false
      if (items.status) {
        this.items = []
        this.items.push(items.data)
        this.formData.ref_id = items.data.id
        this.formData.amount = null
        if(items.data.deposit_amount != null || items.data.deposit_percent != null){
          this.formData.amount = items.data.deposit_amount ? items.data.deposit_amount : items.data.deposit_percent * items.data.grandtotal / 100
        }
        this.max = items.data.grandtotal
        // if(this.items.length === 0) {
        //   this.items.push(items.data)
        // } else {
        //   for (let index = 0; index < items.length; index++) {
        //     const element = items[index]
        //     const document = _.find(this.items, { uuid: element.uuid })
        //     if (!document) {
        //       this.items.push(items.data)
        //     }
        //   }
        // }
      }
    },
    onselectDocument() {
      this.docOpened = !this.docOpened
    },
    onRemoveCustomer(id) {
      const index = _.findIndex(this.customer, function(o) { return o.uuid == id })
      this.customer.splice(index, 1)
    },
    onInitCustomer(item) {
      this.customerOpened = false
      this.customer = []
      if (item.data && item) {
        this.customer.push(item.data)
        this.formData.customer_id = this.customer[0].id
      }
    },
    onselectCustomer() {
      this.customerOpened = !this.customerOpened
    },
    async onLoadBankAccount() {
      try {
        this.loading = true;
        const res = await this.$axios.get(
          this.$host +
          "/api/v1/document/quotation/branch/bank_accounts/type/0"
        );
        this.bank_account_list = res.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;

        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onSubmitForm() {
      this.loading = true
      let result = null

      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        this.loading = false
        return
      }
      this.formData.amount = parseFloat(this.formData.amount)
      this.formData.paid_at = moment(this.formData.paid_at).format("YYYY-MM-DD")
      
      if (this.$route.params.id) {
        result = await this.$store.dispatch('Deposit/update', { form: JSON.stringify(this.formData), Id: this.$route.params?.id }, { root: true })
      } else {
        result = await this.$store.dispatch('Deposit/create', JSON.stringify(this.formData), { root: true })
      }
      
      setTimeout(() => {
        this.loading = false
        if (result?.status === 201 || result?.status === 200) {
                   
          this.$swal({
            width: "29rem",
            padding: '1.825em',
            html: '<div class="d-flex flex-row align-items-center">' +
              '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
              '<div class="d-flex flex-column">'+
              '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
              '<span class="text-base text-left text-gray-500">บันทึกข้อมูลเรียบร้อยแล้ว</span>'+
              '</div>'+
            '</div>',
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                popup: 'swal2-custom-rounded',
                closeButton: 'text-3xl swal2-custom-close',
                actions: 'justify-content-end',
                contant: 'd-flex flex-row justify-content-around px-2',
                title: 'd-none',
                confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
              },
              cancelButtonColor: '#dc4a38',
              cancelButtonText: 'ยกเลิก',
              confirmButtonText: "ตกลง",
              showCancelButton: false,
              showCloseButton: true,
          }).then(async confirm => {
            if(confirm.value) {
              this.onClearData()
              this.$router.push("/deposit");
            }
          })
        } else {
          this.onExceptionHandler((result && result.data && result.data.message) || 'ไม่พบข้อมูล');
        }
      }, 1000);
    },
    onEventClose() {
      this.$emit('componentInfo', { 
        status: true,
        component: 'deposit-list'
      })
    },
    onEventQtyChange(e, id) {
      let value = parseInt(e)
      let result = _.find(this.items, { uuid: id })
      if (result) {
        result.deposit = value
      }
    },    
    onInitData() {
      if (this.$route.params?.id) {
        try {
          this.loading = true
          setTimeout(async () => {
            const param = {
              _id: this.$route.params?.id
            }
            const result = await this.$store.dispatch('Deposit/get', param, { root: true })
            // 403/404/500 ต้องปิด overlay และแจ้งสาเหตุ ไม่งั้นค้างถาวร
            this.loading = false
            if (!result || result.status !== 200) {
              this.onExceptionHandler((result && result.data && result.data.message) || 'โหลดข้อมูลใบมัดจำไม่สำเร็จ')
              return
            }
            if (result.status === 200) {
              // this.onFormBuild(result.data)
              this.formData.document_no = result.data.document_no
              this.formData.paid_at = new Date(result.data.paid_at)
              // โหลดลูกค้าที่เคยเลือกตอนสร้างกลับมาแสดงในตาราง (ไม่งั้นข้อมูลลูกค้าหาย)
              if (result.data.customer) {
                this.onInitCustomer({ data: result.data.customer })
              } else {
                this.formData.customer_id = result.data.customer_id
              }
              // this.formData.receipt_id = result.data.receipt_id
              this.formData.ref_id = result.data.ref_id
              this.formData.tax_type = result.data.tax_type != null ? result.data.tax_type : 0
              this.formData.note = result.data.note || ''
              // pre-select บัญชีรับชำระเดิม — DB เก็บเป็น string แต่ option :value เป็น number (id)
              // ต้อง cast เป็น Number ให้ตรง type ไม่งั้น select ไม่ match (strict compare)
              this.formData.bank_account_detail = result.data.bank_account_detail != null && result.data.bank_account_detail !== ''
                ? Number(result.data.bank_account_detail)
                : null

              // const customers = result.data.customers.length > 0 ? result.data.customers[0]: []
              // this.onInitCustomer({ data: customers })

              const bills = Array.isArray(result.data.bills) ? result.data.bills : []
              // มัดจำที่ไม่ผูกบิล (มัดจำลูกค้าตรง) จะไม่มี bills → ข้ามการ init document
              if (bills.length > 0) {
                this.onInitDocuments({ status: true, data: bills[0] })
              }
              // amount = ยอดสุทธิรวม VAT (นิยามใหม่) — ใบเก่า type 1 amount เก็บเป็นยอดก่อน VAT
              // จึงใช้ grand_total (สุทธิ) ถ้ามี เพื่อให้ตรงกับนิยามใหม่ ไม่งั้น edit แล้วยอดเพี้ยน
              this.formData.amount = result.data.grand_total != null
                ? result.data.grand_total
                : result.data.amount

            }
          }, 1000);
        } catch (error) {
          this.loading = false
          this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
        }
      }
    }
  }
}
